class Accordion {
  constructor(root) {
    this.root = root;

    this.toggles = this.root.querySelectorAll('.js-accordion-toggle');

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        if(toggle.getAttribute('aria-expanded') == 'true') {
          toggle.parentElement.classList.remove('--active');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          this.closeAllPanels();
          toggle.parentElement.classList.add('--active');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  closeAllPanels() {
    this.toggles.forEach((toggle) => {
      toggle.parentElement.classList.remove('--active');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.js-accordion');
  if (accordions.length > 0) {
    const accordionsArray = [...accordions];
  
    accordionsArray.forEach((accordion) => {
      new Accordion(accordion)
    });
  }
});
